import React, { useEffect, useRef, useState } from "react";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
} from "chart.js";

import styles from '../assets/css/gapsy-navbar.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { MakerChartreport, getshariahconfig } from '../components/ApiProperty';
import axios from "axios";
import { Modal } from 'react-bootstrap';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [dateFilterpdf, setDateFilterpdf] = useState("All");
  const [modalMessage, setModalMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success', 'warning', 'danger'
  const [dateFilter, setDateFilter] = useState("all");
  let csrfToken = sessionStorage.getItem("tokenizedSession");
  // const [users, setUsers] = useState([]);
  // const [filteredUsers, setFilteredUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [canDownloadShariahReport, setCanDownloadShariahReport] = useState(false);
  const [canDownloadComplaintsReport, setCanDownloadComplaintsReport] = useState(false);
  const [canDownloadMediaReport, setCanDownloadMediaReport] = useState(false);
  const [canDownloadOperationalReport, setCanDownloadOperationalReport] = useState(false);
  const [canDownloadLeadershipReport, setCanDownloadLeadershipReport] = useState(false);
  const [canDownloadComplianceReport, setCanDownloadComplianceReport] = useState(false);
  const [isRmaExpanded, setIsRmaExpanded] = useState(false);
  const [isRmaReportsExpanded, setIsRmaReportsExpanded] = useState(false);

  const currentPath = location.pathname;
  // Check active routes for dropdown Template Creatuib 
  const templateRoutes = [
    '/gapsyMqem',
    '/GapsyBDMupload',
    '/gapsyAutomatedupload',
    '/gapsyQERejectData',
    '/gapsyQEApproveData',
    '/gapsyEditTemplateForm'
  ];

  const handleDashboard = (e) => {
    e.preventDefault();
    navigate('/gapsyMdashboard');
  }


  const handleShariah = (e) => {
    e.preventDefault();
    navigate('/gapsyShariah');
  }

  const handleComplaintsList = (e) => {
    e.preventDefault();
    navigate('/gapsyMakerComplaintsList');
  }

  const handleMediaReport = (e) => {
    e.preventDefault();
    navigate('/GapsyMediaReport');
  }

  const handleOperationalReport = (e) => {
    e.preventDefault();
    navigate('/GapsyOperationalReport');
  }

  const handleLeadershipReport = (e) => {
    e.preventDefault();
    navigate('/GapsyLeadershipReport');
  }

  const handleComplianceReport = (e) => {
    e.preventDefault();
    navigate('/GapsyComplianceReport');
  }

  const handleMediaList = (e) => {
    e.preventDefault();
    navigate('/gapsyMakerMediaList');
  }

  const handleLeadershipList = (e) => {
    e.preventDefault();
    navigate('/gapsyMakerLeadershipList');
  }

  const handleOperationalList = (e) => {
    e.preventDefault();
    navigate('/gapsyMakerOperationalList');
  }

  const handleComplianceList = (e) => {
    e.preventDefault();
    navigate('/gapsyMakerComplianceList');
  }

  const handleNewReport = (e) => {
    e.preventDefault();
    navigate('/gapsyMakerReportList');
  }

  const handleShariahList = (e) => {
    e.preventDefault();
    navigate('/gapsyShariahList');
  }

  const handleComplaintsReport = (e) => {
    e.preventDefault();
    navigate('/GapsyComplaintsReport');
  }


  const handleResidualOperationalRiskList = (e) => {
    e.preventDefault();
    navigate('/gapsyResidualCreditRiskList');
  }

  const handleShariahRetrieve = (e) => {
    e.preventDefault();
    navigate('/gapsyShariahModifyRetrieval');
  }

  const handleShariahPast = (e) => {
    e.preventDefault();
    navigate('/gapsyShariahPastRetrieval');
  }


  const handleShariah1 = (e) => {
    e.preventDefault();
    navigate('/gapsyShariahRajni');
  }

  const handleMqem = (e) => {
    e.preventDefault();
    navigate('/gapsyMqem');
  }

  const handleBulkUpload = (e) => {
    e.preventDefault();
    navigate('/GapsyBDMupload');
  }

  const handleAutomateDataLoad = (e) => {
    e.preventDefault();
    navigate('/gapsyAutomatedupload');
  }

  const handleShariahReport = (e) => {
    e.preventDefault();
    navigate('/GapsyShariahReport');
  }

  useEffect(() => {
    fetchUsers();
  }, []);

  // const fetchUsers = async () => {
  //   try {

  //     const config = {
  //       headers: {
  //         userId: localStorage.getItem("userid"),
  //         "x-csrf-token": csrfToken,
  //       },
  //       withCredentials: true,
  //       params: {
  //         userId: localStorage.getItem("userid"),
  //         // templateName: "Risk_shariah_pillar1",
  //         templateName: "Shariah Risk",
  //       },
  //     };

  //     const response = await axios.post(getshariahconfig, {}, config);

  //     const apiData = [{
  //       templateName: response.data.templateName,
  //       permissions: response.data.data,
  //     }];

  //     // setSelectedTemplate(response.data.templateName);
  //     // setUsers(apiData);
  //     // setFilteredUsers(apiData);

  //     const loggedInUserId = localStorage.getItem("userid");

  //     const hasDownloadPermission = response.data.data.some(
  //       (item) =>
  //         item.userId === loggedInUserId &&
  //         item.download === "Y"
  //     );

  //     setCanDownloadShariahReport(hasDownloadPermission);

  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const fetchUsers = async () => {
    try {
      setIsLoading(true);

      const loggedInUserId = String(
        localStorage.getItem("userid") || ""
      );

      const baseConfig = {
        headers: {
          userId: loggedInUserId,
          "x-csrf-token": csrfToken,
        },
        withCredentials: true,
      };

      // Fetch Shariah Risk permissions.
      const shariahResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Shariah Risk",
          },
        }
      );

      const shariahPermissions = Array.isArray(shariahResponse.data?.data)
        ? shariahResponse.data.data
        : [];

      const hasShariahPermission = shariahPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadShariahReport(hasShariahPermission);

      // Fetch Customer Complaints permissions.
      const complaintsResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Customer Complaints",
          },
        }
      );

      const complaintsPermissions = Array.isArray(complaintsResponse.data?.data)
        ? complaintsResponse.data.data
        : [];

      const hasComplaintsPermission = complaintsPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadComplaintsReport(hasComplaintsPermission);

      const mediaResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Media Publicity",
          },
        }
      );

      const mediaPermissions = Array.isArray(mediaResponse.data?.data)
        ? mediaResponse.data.data
        : [];

      const hasMediaPermission = mediaPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadMediaReport(hasMediaPermission);

      const operationalResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Operational Thresholds",
          },
        }
      );

      const operationalPermissions = Array.isArray(operationalResponse.data?.data)
        ? operationalResponse.data.data
        : [];

      const hasOperationalPermission = operationalPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadOperationalReport(hasOperationalPermission);

      const leadershipResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Leadership Thresholds",
          },
        }
      );

      const leadershipPermissions = Array.isArray(leadershipResponse.data?.data)
        ? leadershipResponse.data.data
        : [];

      const hasLeadershipPermission = leadershipPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadLeadershipReport(hasLeadershipPermission);

      const complianceResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Leadership Thresholds",
          },
        }
      );

      const compliancePermissions = Array.isArray(complianceResponse.data?.data)
        ? complianceResponse.data.data
        : [];

      const hasCompliancePermission = compliancePermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadComplianceReport(hasCompliancePermission);



    } catch (error) {
      console.error("Error fetching report permissions:", error);

      setCanDownloadShariahReport(false);
      setCanDownloadComplaintsReport(false);
      setCanDownloadMediaReport(false);
      setCanDownloadComplianceReport(false);
      setCanDownloadOperationalReport(false);
      setCanDownloadLeadershipReport(false);

    } finally {
      setIsLoading(false);
    }
  };


  // Check if the current path matches any child route
  const isTemplateActive = templateRoutes.some(route => currentPath.startsWith(route));

  const dept = localStorage.getItem("dept");

  // to Download a pdf
  const handleGenerateMakerReport = async (selectedFilter) => {
    const appliedFilter = selectedFilter;
    try {
      const userId = localStorage.getItem("userid");
      const userRole = localStorage.getItem("userRole");
      const username = localStorage.getItem("username");

      const Userdept = localStorage.getItem("dept");
      const getDisplayDept = (dept) => (dept === "Finance" ? "Finance and Planning" : dept);

      const Activty = 'R';

      const config = {
        headers: { userId, "x-csrf-token": csrfToken },
        withCredentials: true,
        params: { userRole, dept, dateFilter: appliedFilter, Activty: Activty },
      };

      const response = await axios.post(MakerChartreport, {}, config);
      const dataInfo = response.data?.["data Information"];
      if (!dataInfo) return;



      // Aggregate table data
      const allTables = [];
      let chartData = [0, 0];

      const processDepartmentData = (deptName, deptData) => {
        const submitted = deptData[0]?.["Submitted Tables"] || [];
        const modified = deptData[1]?.["Modified Tables"] || [];

        chartData[0] += deptData[0]?.["Submitted Table count"] || 0;
        chartData[1] += deptData[1]?.["Modified Table count"] || 0;

        const uniqueTables = new Map();

        submitted.forEach((t) => {
          const key = `${deptName}_${t["Table Name"]}`;
          uniqueTables.set(key, { ...t, deptName, source: "Submitted" });
        });

        modified.forEach((t) => {
          const key = `${deptName}_${t["Table Name"]}`;
          if (!uniqueTables.has(key)) {
            uniqueTables.set(key, { ...t, deptName, source: "Modified" });
          }
        });

        allTables.push(...Array.from(uniqueTables.values()));
      };

      if (dept === "IT") {
        for (const [dName, dData] of Object.entries(dataInfo)) {
          processDepartmentData(dName, dData);
        }
      } else {
        if (!dataInfo[dept]) return;
        processDepartmentData(dept, dataInfo[dept]);
      }

      if (chartData[0] + chartData[1] === 0) {
        setModalMessage("No activity is available for the selected Interval");
        setMessageType("warning");
        return;
      }

      let chartImage = null;

      if (dept === "IT") {
        // ✅ Prepare Doughnut chart data
        const deptEntries = Object.entries(dataInfo || {});
        const doughnutLabels = [];
        const doughnutData = [];
        const doughnutColors = [];

        const gradientColors = [
          "#07beb8", "#f25c54", "#ffd166", "#118ab2", "#06d6a0", "#ef476f", "#8338ec", "#ffbe0b"
        ];

        let colorIndex = 0;

        deptEntries.forEach(([deptName, deptData]) => {
          const count = deptData?.[0]?.["Submitted Table count"] || 0;
          if (count > 0) {
            doughnutLabels.push(deptName);
            doughnutData.push(count);
            doughnutColors.push(gradientColors[colorIndex % gradientColors.length]);
            colorIndex++;
          }
        });
        chartImage = await generateITDoughnutChartImage(doughnutLabels, doughnutData);

        // chartImage = await generateITDoughnutChartImage(doughnutLabels, doughnutData, doughnutColors);
      } else {
        chartImage = await generateMakerChartImage(chartData, setModalMessage, setMessageType);
      }

      const pdf = new jsPDF("l", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      pdf.setLineWidth(0.5);
      pdf.setDrawColor(0, 0, 0);
      pdf.rect(10, 10, pageWidth - 20, pageHeight - 20);

      pdf.setFont("helvetica", "bold");
      pdf.text("Audit Report - Data Summary", pageWidth / 2, 18, { align: "center" });

      const dateFilterLabels = {
        All: "All Days",
        Today: "Today",
        last3days: "Last 3 Days",
        last7days: "Last 7 Days",
        last30days: "Last 30 Days",
      };
      const reportIntervalLabel = dateFilterLabels[appliedFilter] || dateFilter;
      let y = 25;
      const lineHeight = 5;
      pdf.setFont('helvetica', 'normal');

      pdf.setFontSize(8);
      pdf.setTextColor(60, 60, 60);
      const downloadTime = new Date().toLocaleString();


      // ➤ Department on the left, Report Interval on the right (same line)
      pdf.text(`Department : ${getDisplayDept(Userdept)}`, 20, y);
      pdf.text(`Report Interval : ${reportIntervalLabel}`, pageWidth - 20, y, { align: 'right' });

      y += lineHeight;
      pdf.text(`Generated By : ${userId} (${userRole})`, 20, y);

      y += lineHeight;
      pdf.text(`Generated On : ${downloadTime}`, 20, y);

      const imgWidth = 70.23;
      const imgHeight = 60.09;
      const chartX = (pageWidth - imgWidth) / 2;
      const chartY = 45;
      if (chartImage) {
        pdf.addImage(chartImage, "PNG", chartX, chartY, imgWidth, imgHeight);
      }

      const headers = [
        [
          "S.No",
          "Department Name",
          "Table Name",
          "No.of Columns",
          "No.of Data Submitted",
          "No.of Data Modified",
          "Last Submitted By",
          "Last Submitted Date",
          "Last Modified By",
          "Last Modified Date"
        ],
      ];

      const formatName = (name) => {
        if (!name) return "-";

        // Remove the department prefix (everything before first underscore)
        const noPrefix = name.replace(/^[^_]+_/, "");

        // Capitalize each word
        return noPrefix
          .split("_")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      };

      const formatDate = (dt) => (dt ? dt.split(" ")[0] : "-");

      const rows = allTables.map((item, idx) => [
        idx + 1,
        getDisplayDept(item.deptName) || "-",
        formatName(item["Table Name"]),
        item["No.of.columns"] ?? "-",
        item["Submitted Records"] ?? "-",
        item["Modified Records"] ?? "-",
        item["Submitted_by"] || "-",
        formatDate(item["Last Submitted Date"]),
        item["modified_by"] || "-",
        formatDate(item["Last Modified Date"])
      ]);

      autoTable(pdf, {
        startY: chartY + imgHeight + 10,
        head: headers,
        body: rows,
        styles: {
          fontSize: 7,
          cellPadding: 1.5,
          halign: "left",
          valign: "middle",
          overflow: "linebreak",
          minCellHeight: 5,
        },
        headStyles: {
          fillColor: [245, 245, 245],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          fontSize: 7,
          lineWidth: 0.1,
          lineColor: 180,
        },
        bodyStyles: {
          textColor: 50,
          lineWidth: 0.1,
          lineColor: 200,
        },
        theme: "grid",
        didDrawPage: () => {
          pdf.setLineWidth(0.8);
          pdf.setDrawColor(0, 0, 0);
          pdf.rect(10, 10, pageWidth - 20, pageHeight - 20);
        },
      });

      pdf.save(`Audit Report - Data Summary_${Date.now()}.pdf`);
    } catch (err) {
      console.error("❌ PDF generation failed:", err);
    }
  };


  const handleCloseModal = () => {
    setModalMessage("");
    setMessageType("");
  };





  const initialColors = ['#9966FF', '#7AC74F', '#FF69B4', '#FFCE56']; // Base palette

  function generateSafeColors(count) {
    const colors = [...initialColors];
    let hue = 30;

    while (colors.length < count) {
      // Avoid red (0–20, 340–360) and blue (180–260)
      if ((hue >= 0 && hue <= 20) || (hue >= 180 && hue <= 260) || (hue >= 340 && hue <= 360)) {
        hue = (hue + 15) % 360;
        continue;
      }

      const color = `hsl(${hue}, 70%, 55%)`;
      if (!colors.includes(color)) {
        colors.push(color);
      }

      hue = (hue + 30) % 360;
    }

    return colors.slice(0, count);
  }

  const generateITDoughnutChartImage = async (labels, data) => {
    const canvas = document.getElementById("hiddenExportChart");
    if (!canvas) return null;

    const ctx = canvas.getContext("2d");


    if (canvas._chartInstance) {
      canvas._chartInstance.destroy();
    }

    const colors = generateSafeColors(data.length);

    canvas._chartInstance = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels,
        datasets: [{
          data,
          backgroundColor: colors,
          borderColor: colors,
          borderWidth: 1,
        }],
        totalUsers: data.reduce((a, b) => a + b, 0),
      },
      options: {
        responsive: false,
        animation: false,
        cutout: "60%",
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            align: 'center',
            labels: {
              color: 'black',
              font: { size: 15, weight: 'bold', family: 'Arial, sans-serif' },
              boxWidth: 15,
              padding: 10,
              generateLabels(chart) {
                const dataset = chart.data.datasets[0];
                const labels = chart.data.labels;
                return labels.map((label, i) => ({
                  text: `${label} (${dataset.data[i]})`,
                  fillStyle: dataset.backgroundColor[i],
                  strokeStyle: dataset.borderColor[i],
                  lineWidth: 1,
                  hidden: !chart.isDatasetVisible(0),
                  index: i,
                }));
              },
            },
          },
          tooltip: { enabled: true },
        },
      },
      plugins: [
        {
          id: 'segment3DEffect',
          afterDatasetDraw(chart) {
            const { ctx } = chart;
            const meta = chart.getDatasetMeta(0);
            const dataset = chart.data.datasets[0];

            ctx.save();
            meta.data.forEach((arc, index) => {
              const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;
              const gradient = ctx.createRadialGradient(x, y, innerRadius, x, y, outerRadius);
              const baseColor = dataset.backgroundColor[index];

              gradient.addColorStop(0, 'rgba(255, 255, 255, 0.3)');
              gradient.addColorStop(0.5, baseColor);
              gradient.addColorStop(1, 'rgba(0, 0, 0, 0.15)');

              ctx.fillStyle = gradient;

              ctx.beginPath();
              ctx.moveTo(x, y);
              ctx.arc(x, y, outerRadius, startAngle, endAngle);
              ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
              ctx.closePath();
              ctx.fill();

              ctx.shadowColor = 'rgba(0,0,0,0.08)';
              ctx.shadowBlur = 3;
              ctx.shadowOffsetX = 1;
              ctx.shadowOffsetY = 1;

              ctx.strokeStyle = 'rgba(0, 0, 0, 0.08)';
              ctx.lineWidth = 1;
              ctx.beginPath();
              ctx.arc(x, y, outerRadius, startAngle, endAngle);
              ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
              ctx.closePath();
              ctx.stroke();

              ctx.shadowColor = 'transparent';
              ctx.shadowBlur = 0;
              ctx.shadowOffsetX = 0;
              ctx.shadowOffsetY = 0;
            });
            ctx.restore();
          },
        },
        {
          id: 'centerText',
          beforeDraw(chart) {
            const { ctx, chartArea, data } = chart;
            const total = data.totalUsers || 0;
            ctx.save();
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = '20px Arial';
            ctx.fillStyle = 'black';
            ctx.fillText('Total', (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 - 20);
            ctx.font = '30px Arial';
            ctx.fillText(total.toString(), (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 + 10);
            ctx.restore();
          },
        },
        {
          id: 'segmentCounts',
          afterDatasetDraw(chart) {
            const { ctx } = chart;
            const dataset = chart.data.datasets[0];
            const meta = chart.getDatasetMeta(0);

            ctx.save();
            ctx.fillStyle = 'black';
            ctx.font = 'bold 14px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            meta.data.forEach((arc, index) => {
              const { x, y } = arc.tooltipPosition();
              const value = dataset.data[index];
              ctx.fillText(value, x, y);
            });

            ctx.restore();
          },
        },
      ],
    });

    await new Promise((resolve) => setTimeout(resolve, 300)); // Wait for render
    return canvas.toDataURL("image/png");
  };



  const generateMakerChartImage = async (detailData) => {
    const canvas = document.getElementById("hiddenMakerChart");
    if (!canvas) return null;


    const totalCount = detailData.reduce((a, b) => a + b, 0);
    if (!totalCount) {
      setModalMessage("No activity is available for the selected Interval");
      setMessageType("warning");
      return null;
    }

    const ctx = canvas.getContext("2d");

    if (canvas._chartInstance) {
      canvas._chartInstance.destroy();
    }

    const labels = ["Submitted", "Modified"];
    const data = detailData || [0, 0];

    function createGradient(colorStart, colorEnd) {
      const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
      gradient.addColorStop(0, colorStart);
      gradient.addColorStop(1, colorEnd);
      return gradient;
    }

    const backgroundColors = [];
    backgroundColors.push(createGradient("#967aa1", "#07beb8")); // gradient1
    backgroundColors.push(createGradient("#967aa1", "#f25c54")); // gradient2

    canvas._chartInstance = new Chart(ctx, {
      type: "bar",
      data: {
        labels: labels.map((label, i) => `${label} (${data[i]})`),
        datasets: [
          {
            data,
            backgroundColor: backgroundColors,
            borderRadius: 0,
            barPercentage: 0.5,
            categoryPercentage: 0.5,
          },
        ],
      },
      options: {
        responsive: false,
        animation: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            enabled: true,
            callbacks: {
              title: (ctx) => ctx[0].label.split(" (")[0],
              label: (ctx) => `Count: ${ctx.parsed.y}`,
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "Activity",
              color: "black",
              font: {
                size: 14,
                weight: "bold",
              },
            },
            ticks: {
              color: "black",
              font: {
                size: 16,
                weight: "bold",
              },
            },
            grid: {
              display: false,
            },
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: "Count",
              color: "black",
              font: {
                size: 14,
                weight: "bold",
              },
            },
            ticks: {
              color: "black",
              font: {
                size: 16,
                weight: "bold",
              },
              stepSize: 1,
              precision: 0,
            },
          },
        },
      },
    });

    await new Promise((resolve) => setTimeout(resolve, 300)); // wait for chart render

    return canvas.toDataURL("image/png");
  };


  return (
    <div>
      <nav className={`navbar navbar-expand-lg sticky-nav ${styles.stickyNav} borderBottom`}>
        <div className="container-fluid">
          <ul className="d-flex gap-3 list-unstyled mb-0">
            <li>
              <a className={`${styles.navLink} ${styles.navLinkDefault}
             ${currentPath === '/gapsyMdashboard' ? styles.active : ''
                }`} href="#" onClick={handleDashboard}>
                <i className="bi bi-display"></i> Home
              </a>
            </li>

            <li className="dropdown">
              <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault} ${styles.dropdownToggle}
            ${isTemplateActive ? styles.active : ''
                }`} href="#" data-bs-toggle="dropdown">
                <i className="bi bi-shield-lock"></i> Data Submission
              </a>
              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleMqem}>
                    <i className="bi bi-input-cursor-text"></i> 2.1 Quick Entry
                  </a>
                </li>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleBulkUpload}>
                    <i className="bi bi-file-earmark-arrow-up"></i> 2.2 Bulk Upload
                  </a>
                </li>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleAutomateDataLoad}>
                    <i className="bi bi-arrow-repeat"></i> 2.3 Automated Data Load
                  </a>
                </li>
              </ul>
            </li>

            <li className={`dropdown ${styles.dropdown}`}>
              <a className={`dropdown-toggle rounded-0 ${styles.navLink} ${styles.navLinkDefault}`} href="#" data-bs-toggle="dropdown">
                <i className="bi bi-box"></i> Reports
              </a>
              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                <li className={`${styles.dropdownSubmenu}`}>
                  <a
                    className={`dropdown-item dropdown-toggle ${styles.dropdownItem}`}
                    href="#"
                    role="button"
                    aria-expanded="false"
                  >
                    <i className="bi bi-file-richtext me-2"></i>
                    Audit Report - Data Summary
                  </a>

                  <ul className={`dropdown-menu rounded-0 ${styles.submenu} ${styles.dropdownMenuStyled}`}>
                    {["last7days", "last30days", "All"].map((option) => (
                      <li className={`${styles.dropdownSubmenu}`} key={option}>
                        <button
                          className={`dropdown-item ${styles.dropdownItem}`}
                          onClick={() => {
                            setDateFilterpdf(option);
                            handleGenerateMakerReport(option);
                          }}
                        >
                          {option === "last7days"
                            ? "Last 7 Days"
                            : option === "last30days"
                              ? "Last 30 Days"
                              : "All"}
                        </button>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </li>

            {dept === 'Risk' && (
              <li className="dropdown">
                <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault} ${styles.dropdownToggle}
            ${isTemplateActive ? styles.active : ''
                  }`} href="#" data-bs-toggle="dropdown">
                  <i className="bi bi-shield-lock"></i> Pillar 2 Risk
                </a>
                <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleShariahList}>
                      <i className="bi bi-input-cursor-text"></i> Shariah
                    </a>
                  </li>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleResidualOperationalRiskList}>
                      <i className="bi bi-soundwave"></i> Residual Operational Risk
                    </a>
                  </li>
                  {canDownloadShariahReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleShariahReport}
                        href="#"
                      >
                        <i className="bi bi-graph-up"></i> Shariah Report
                      </a>
                    </li>
                  )}

                </ul>
              </li>
            )}

            {dept === 'Risk' && (
              <li className="dropdown">
                <a
  className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault} ${styles.dropdownToggle}
    ${isTemplateActive ? styles.active : ''}`}
  href="#"
  data-bs-toggle="dropdown"
  onMouseEnter={() => setIsRmaExpanded(true)}
  onMouseLeave={() => setIsRmaExpanded(false)}
>
  <i className="bi bi-shield-lock"></i>{" "}
  {isRmaExpanded ? "Risk Measurement Attributes" : "RMA"}
</a>
                <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleComplaintsList}>
                      <i className="bi bi-input-cursor-text"></i> Complaints
                    </a>
                  </li>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleMediaList}>
                      <i className="bi bi-soundwave"></i> Media Publicity
                    </a>
                  </li>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleLeadershipList}>
                      <i className="bi bi-people"></i> Leadership
                    </a>
                  </li>
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleOperationalList}>
                      <i className="bi bi-gear"></i> Operational
                    </a>
                  </li>

                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} href="#" onClick={handleComplianceList}>
                      <i className="bi bi-clipboard-check"></i> Compliance
                    </a>
                  </li>

                  {(() => {
                    const title = localStorage.getItem("excelTitle")?.trim();

                    if (!title) return null;

                    return (
                      <li>
                        <a
                          className={`dropdown-item ${styles.dropdownItem}`}
                          onClick={handleNewReport}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-file-earmark-text"></i>{" "}
                          {title}
                        </a>
                      </li>
                    );
                  })()}
                </ul>
              </li>
            )}

            {dept === "Risk" && (
              <li className={`dropdown ${styles.dropdown}`}>
                <a
  className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault}`}
  href="#"
  data-bs-toggle="dropdown"
  onMouseEnter={() => setIsRmaReportsExpanded(true)}
  onMouseLeave={() => setIsRmaReportsExpanded(false)}
>
  <i className="bi bi-file-earmark-bar-graph"></i>{" "}
  {isRmaReportsExpanded
    ? "Risk Measurement Attributes Reports"
    : "RMA Reports"}
</a>
                <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>

                  {canDownloadComplaintsReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleComplaintsReport}
                        href="#"
                      >
                        <i className="bi bi-graph-up"></i> Complaints Report
                      </a>
                    </li>
                  )}
                  {canDownloadMediaReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleMediaReport}
                        href="#"
                      >
                        <i className="bi bi-graph-up"></i> Media Publicity Report
                      </a>
                    </li>
                  )}
                  {canDownloadLeadershipReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleLeadershipReport}
                        href="#"
                      >
                        <i className="bi bi-people"></i> Leadership Report
                      </a>
                    </li>
                  )}
                  {canDownloadOperationalReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleOperationalReport}
                        href="#"
                      >
                        <i className="bi bi-gear"></i> Operational Report
                      </a>
                    </li>
                  )}
                  {canDownloadComplianceReport && (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleComplianceReport}
                        href="#"
                      >
                        <i className="bi bi-clipboard-check"></i> Compliance Report
                      </a>
                    </li>
                  )}
                </ul>
              </li>
            )}

          </ul>
        </div>
      </nav>

      <canvas
        id="hiddenMakerChart"
        width={400}
        height={300}
        style={{ display: "none" }}
      ></canvas>
      <canvas
        id="hiddenExportChart"
        width={350}
        height={300}
        style={{ display: 'none' }}
      ></canvas>
      <Modal
        show={!!modalMessage}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        style={{ marginTop: '12vh' }}
      >
        <div
          className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
          role="alert"
          style={{ marginBottom: '0' }}
        >
          <div className="d-flex align-items-center">
            {messageType === 'success' ? (
              <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
            ) : messageType === 'warning' ? (
              <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
            ) : (
              <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
            )}
            <p
              style={{
                display: 'inline',
                marginBottom: '0px',
                color: messageType === 'success'
                  ? 'green'
                  : messageType === 'warning'
                    ? '#ffc107'
                    : 'red'
              }}
            >
              {modalMessage}
            </p>
          </div>
          <button
            type="button"
            className="btn-close"
            onClick={handleCloseModal}
            style={{
              width: '15px',
              height: '15px',
              fontSize: '8px',
              position: 'absolute',
              bottom: '10px',
              right: '10px'
            }}
          />
        </div>
      </Modal>

    </div>

  );
};

export default Navigation;
